'use strict';

function ARGB2HexFilter() {
  return function(color) {
    return '#'+ ('000000' + (color & 0xFFFFFF).toString(16)).slice(-6);
  };
}

function Hex2ARGBFilter() {
  return function(color) {
    if (7 !== color.length) {
      return 0;
    }

    return parseInt("FF" + color.substr(1), 16);
  };
}

angular.module('dokiv')
  .filter('ARGB2HexFilter', ARGB2HexFilter)
  .filter('Hex2ARGBFilter', Hex2ARGBFilter);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ARGB2HexFilter.js
// module id = 233
// module chunks = 0